import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import Header from './components/Header';
import Footer from './components/Footer';

import Home from './pages/Home';
import OurStory from './pages/OurStory';
import Services from './pages/ServicesMVP';
import LeadershipPage from './pages/Leadership';
import ExploreCauses from './pages/ExploreCauses';
import Donate from './pages/Donate';
import GeneralDonate from './pages/GeneralDonate';
import ImpactAcademy from './pages/ImpactAcademy';
import CostCalculatorPage from './pages/CostCalculatorPage';
import AnnualReport from './pages/AnnualReport';
import Platform from './pages/Platform.jsx';
import Transparency from './pages/Transparency.jsx';
import TermsOfService from './pages/TOS.jsx';
import PrivacyPolicy from './pages/PrivacyPolicy.jsx';

import ApplicationWebToLead from './components/ApplicationWebToLead.jsx';
import ApplicationSubmitted from './pages/ApplicationSubmitted.jsx';
import ContactUsWebToLead from './components/ContactUsWebToLead.jsx';
import ContactSubmitted from './pages/ContactSubmitted.jsx';

import GoogleAnalytics from './components/GoogleAnalytics';
import { trackPageView } from './utils/analytics';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import '@fortawesome/fontawesome-svg-core/styles.css';

import { Toaster } from 'react-hot-toast';

library.add(fas, far, fab);

function App() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  return (
    <HelmetProvider>
      <GoogleAnalytics />

      <Header />

      <main>
        <Routes>
          {/* Main public website */}
          <Route path="/" element={<Home />} />
          <Route path="/our-story" element={<OurStory />} />
          <Route path="/leadership" element={<LeadershipPage />} />
          <Route path="/services" element={<Services />} />
          <Route path="/causes" element={<ExploreCauses />} />

          {/* Donations */}
          <Route path="/donate" element={<GeneralDonate />} />
          <Route path="/donate/:causeId" element={<Donate />} />

          {/* Fiscal Sponsorship Application */}
          <Route path="/apply" element={<ApplicationWebToLead />} />
          <Route
            path="/application-submitted"
            element={<ApplicationSubmitted />}
          />

          {/* Contact */}
          <Route path="/contact-us" element={<ContactUsWebToLead />} />
          <Route path="/contact-submitted" element={<ContactSubmitted />} />

          {/* Resources */}
          <Route path="/academy" element={<ImpactAcademy />} />
          <Route path="/calculator" element={<CostCalculatorPage />} />
          <Route path="/cost-calculator" element={<CostCalculatorPage />} />
          <Route path="/financials" element={<AnnualReport />} />
          <Route path="/platform" element={<Platform />} />
          <Route path="/transparency" element={<Transparency />} />

          {/* Legal */}
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>
      </main>

      <Footer />
      <Toaster position="top-right" />
    </HelmetProvider>
  );
}

export default App;